import { BRAND } from "@/lib/brand";

export default function Gallery() {
  const images = BRAND.images.gallery;

  return (
    <section
      id="gallery"
      className="relative py-24 sm:py-32 border-t border-white/5"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <div className="text-xs uppercase tracking-[0.35em] text-brand mb-4 flex items-center gap-3">
              <span className="h-px w-10 bg-brand" /> Moments
            </div>
            <h2
              className="text-4xl sm:text-5xl lg:text-6xl font-serif leading-[1.02]"
              data-testid="gallery-title"
            >
              Polaroids from
              <br />
              <span className="italic text-brand">the sisterhood.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-sm text-sm leading-relaxed">
            Every curve, every sunset, every late-night laugh — moments from
            rides, events and the sisters behind the crown.
          </p>
        </div>

        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3"
          data-testid="gallery-grid"
        >
          {images.map((src, i) => {
            const isVideo = /\.(mp4|webm|mov)$/i.test(src);
            return (
              <figure
                key={i}
                className="relative overflow-hidden group bg-[#0a0a0a] aspect-[3/4]"
                data-testid={`gallery-item-${i}`}
              >
                {isVideo ? (
                  <video
                    src={src}
                    controls
                    playsInline
                    preload="none"
                    poster="/gallery/ride-22.jpg"
                    className="absolute inset-0 w-full h-full object-contain bg-[#050505]"
                    data-testid={`gallery-video-${i}`}
                  />
                ) : (
                  <img
                    src={src}
                    alt={`Crown Jewels moment ${i + 1}`}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-contain bg-[#050505] group-hover:scale-105 transition-transform duration-[1200ms]"
                  />
                )}
                {!isVideo && (
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-opacity pointer-events-none" />
                )}
                {isVideo && (
                  <span className="absolute top-3 left-3 z-10 text-[10px] uppercase tracking-[0.25em] text-brand bg-[#050505]/80 border border-brand/40 px-2 py-1">
                    ▶ Video
                  </span>
                )}
                <figcaption className="absolute bottom-3 left-3 text-[10px] uppercase tracking-[0.25em] text-white/70 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                  Crown Jewels · Houston
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
